import React from "react";
import loadContent from "core-module/hoc/loadContent";
import { Component } from "react";
import { withRouter } from "react-router";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  }
};

class BalanceDue extends Component {

  componentDidMount() {
    this.props.setBills(this.props.getData("pastdue"), this.props.getData("current"));
  }

  componentDidUpdate() {
    this.props.setBills(this.props.getData("pastdue"), this.props.getData("current"));
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.getData("pastdue") != this.props.pastDue || nextProps.getData("current") != this.props.current;

  }

  displayText(dollarValue) {
    if (dollarValue >= 0) {
      return '$'+dollarValue; 
    } else {
      return 'CR $'+(dollarValue*-1)+' (credit)';
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <>
        <h3 className={classes.text}>Past Due: {this.displayText(this.props.pastDue)}</h3>
        <h3 className={classes.text}>Current Invoice: {this.displayText(this.props.current)}</h3>
      </>
    );
  }

}
export default withStyles(styles)(withRouter(loadContent(`user.session/accountbalance`, BalanceDue, null, true)));